import { buildSplunkUrl } from './build-splunk-url';
import { getSplunkTimeRangeParams } from './get-splunk-time-range-params';

/**
 * Returns a Splunk search URL for an intent-detection trace ID.
 *
 * Intent-detection logs live in the `micros_xp-knowledge-discovery` source and
 * are indexed under the `traceId` field, so this uses a different query shape
 * than `getSplunkTraceUrl`:
 *
 *   `micros_xp-knowledge-discovery` traceId = "<traceId>"
 *
 * Returns `undefined` when no trace ID is available. Honours the same absolute
 * time-window behaviour as `getSplunkTraceUrl`.
 *
 * @param traceId - The intent-detection trace ID to search for.
 * @param timestamp - Optional time of the request (ISO 8601 string or epoch ms)
 *   used to anchor the Splunk search window.
 */
export const getSplunkIntentDetectionTraceUrl = (
	traceId: string | null | undefined,
	timestamp?: string | number | null,
): string | undefined => {
	if (!traceId) {
		return undefined;
	}

	return buildSplunkUrl(
		`\`micros_xp-knowledge-discovery\` traceId = "${traceId}"`,
		getSplunkTimeRangeParams(timestamp),
	);
};
